// extracted by mini-css-extract-plugin
export default {"container":"otpInput_container__ZKygE","dangerWarn":"otpInput_dangerWarn__KslSI"};